import Choices from "choices.js"

const formsSelects = document.querySelectorAll('.select--forms');
const gfieldSelects = document.querySelectorAll('.gfield select');
const agencySelects = document.querySelectorAll('.select--agency');
const searchSelects = document.querySelectorAll('.select--search');
const searchSelectsAlt = document.querySelectorAll('.select--search--alt');

const applyChoicesCustom = (selectsToCustom, classes) => {
    if (selectsToCustom) {
        selectsToCustom.forEach(select => {
            if (!select.hasAttribute('js-livesearch-tags-results')) {
                const choices = new Choices(select, {
                    searchEnabled: false,
                    shouldSort: false,
                    classNames: {
                        containerOuter: classes,
                    }
                });
            }
        })
    }
}

const applyChoicesDptRegion = (selectsToCustom, classes) => {
    if (selectsToCustom) {
        selectsToCustom.forEach(select => {
            const choices = new Choices(select, {
                searchEnabled: false,
                shouldSort: false,
                shouldSortItems: true,
                classNames: {
                    containerOuter: classes,
                }
            });
        })
    }
}

applyChoicesCustom(formsSelects, 'choices');
applyChoicesCustom(gfieldSelects, 'choices');
applyChoicesCustom(agencySelects, 'choices choices--agency');
applyChoicesCustom(searchSelects, 'choices choices--search');
applyChoicesDptRegion(searchSelectsAlt, 'choices choices--search');
